import { ShopDineRelaxCategory } from '../../../domain/models/ShopDineRelaxCategory';
import { DineIcon, DrinkIcon, ServicesIcon, ShopIcon } from '../../../../../ui';
import { IPoiItem } from '../../../domain/models/IPoiItem';

enum ShopDineRelaxIconCategory {
	Bar = 'eat.bar',
	Dine = ShopDineRelaxCategory.Eat,
	Coffee = 'eat.coffee',
	Vending = 'eat.vending',
	Shop = ShopDineRelaxCategory.Shop,
	Relax = ShopDineRelaxCategory.Relax,
}

export const getPoiCardIcon = (poiItem: IPoiItem): React.ReactNode => {
	const poiCategory = poiItem.category;

	const eatCategories = [
		ShopDineRelaxIconCategory.Dine,
		ShopDineRelaxIconCategory.Coffee,
		ShopDineRelaxIconCategory.Vending,
	];

	if (poiCategory.includes(ShopDineRelaxIconCategory.Shop))
		return <ShopIcon aria-label="Shop" />;

	if (poiCategory.includes(ShopDineRelaxIconCategory.Bar))
		return <DrinkIcon aria-label="Drink" />;

	if (eatCategories.some((category) => poiCategory.includes(category)))
		return <DineIcon aria-label="Dine" />;

	if (poiCategory.includes(ShopDineRelaxIconCategory.Relax))
		return <ServicesIcon aria-label="Services and Relax" />;

	return undefined;
};
